<template>
	<div class="page">
		<div class="center-box-no-footer">
			<van-tabs :active="active">
  <van-tab title="事件一"><bq42201  ref="bq42201" :dataIndex="number1" style="height: 100%;"></bq42201>	</van-tab>
  <van-tab title="事件二"><bq42202  ref="bq42202" :dataIndex="number2" style="height: 100%;"></bq42202></van-tab>
</van-tabs>
						
		</div>
	</div>
</template>

<script>
// 引入服务组件
import componentsModel from '../../../base/components.js'
// 引入子页面的混入对象
import mixinModel from '../mixins/mixins.js'

  import bq42201 from '../../../bq422/form'
  import bq42202 from '../../../bq422/form'
export default {
	name: "page015",
	mixins: [mixinModel],
	data() {
		return {
			modelname: 'bq421',
			form: {
				bq421: {
					id: "0", //编号
					guid: "", //guid编号
					companyGuid: "", //单位编号
					departmentGuid: "", //部门编号
					checkStatus: "", //审核状态
					dataStatus: "", //数据状态
					addUid: "", //添加人编号
					addTime: "", //添加时间					
					Bq400_guid: '', //随访基本信息表编号
					Bq421_002: '', //
					Bq421_003: '', //
					Bq421_004: '', //
					Bq421_005: '', //
					Bq421_006: '', //
				},
				sempFiles: []
			},
			fullscreenLoading: false,
			//保存接口
			saveUrl: this.$utils.Url.s400 + '/api/S400Bq421/Save',
			dataList: [],
			existList: [],
			bq400: JSON.parse(sessionStorage.getItem('bq400')),
			savestate: false,
			number1:1,
			number2:2,
			active: 0,
		}
	},
	components: {
		...componentsModel,		
		bq42201,
		bq42202,
	},
	methods: {
		//加载信息
		LoadInfo: function () {
			var that = this
			var args = {
				bq400guid: this.bq400.guid
			}
			that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq421/Info', args, function (d) {
				let dataModel = d.Data
				if (dataModel != null) {
					that.$utils.CopyKeyInfo(dataModel, dataModel)
					that.$set(that.form, "bq421", dataModel)
				}
			}, null, null, null);
		},

		//保存信息
		SaveInfo: function () {
			let that = this
			that.form.sempFiles = that.$refs.normalUpload.GetFileList()
			that.$refs.btnSave.Save()
		},
	},
	mounted() {
		this.form.bq421.Bq400_guid = this.bq400.guid
		this.existList = this.$utils.setStandardList(this.$apis.s400Apis.existList)
		this.LoadInfo()
	}
}
</script>

<style scoped>

</style>
